import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import DiiaIcon from '~/components/SVG/Diia.svg?react';

const styles: { icon: SxProps<Theme> } = {
  icon: (theme: Theme) => ({
    width: '60px',
    height: '60px',
    [theme.breakpoints.down('sm')]: {
      width: '40px',
      height: '40px',
    },
  }),
};

const Diia = () => {
  return <Box component={DiiaIcon} sx={styles.icon} />;
};

export default Diia;
